module.exports = __webpack_public_path__ + "static/banner.service-d8889b920d90469f4ae93677dda89547.png";